// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","colorSecondary":"#9fd8df"};